import React, { useEffect, useState, useCallback } from 'react'
import type { GA4ProductType, GA4PageNameType } from '@/ga4types'
import useDetectBrowser from '@/hooks/useDetectBrowser'
import TravelChatBotModal from './TravelChatBotModal'
import ChatNotification from './ChatNotification'

const PENNY_PUSH_MESSAGE_DELAY = 200

export type ChatBotPopOverVal = 'CLOSE' | 'OPEN' | 'ALREADY_OPENED'

export default function TravelChatBot({
  enableChatBot,
  openPenny,
  askPrompt,
  pageName,
  productType
}: Readonly<{
  enableChatBot: boolean
  openPenny?: string
  askPrompt?: string
  pageName: GA4PageNameType
  productType?: GA4ProductType
}>) {
  const isBrowser = useDetectBrowser()

  const [openChatBotPopOver, setOpenChatBotPopOver] =
    useState<ChatBotPopOverVal>('CLOSE')
  const [isChatBotDialogOpened, setIsChatBotDialogOpened] = useState(false)
  const [areChatBotFeaturesLoaded, setAreChatBotFeaturesLoaded] =
    useState(false)

  const handleChatBotFeaturesLoaded = useCallback(() => {
    setAreChatBotFeaturesLoaded(true)
  }, [setAreChatBotFeaturesLoaded])

  const handleModalClose = useCallback(() => {
    setIsChatBotDialogOpened(false)
  }, [setIsChatBotDialogOpened])

  useEffect(() => {
    if (
      openPenny === 'y' &&
      ((askPrompt && askPrompt?.length <= 140) || !askPrompt)
    ) {
      setIsChatBotDialogOpened(true)
      setAreChatBotFeaturesLoaded(true)
    }
  }, [openPenny, askPrompt, setIsChatBotDialogOpened])

  useEffect(() => {
    if (areChatBotFeaturesLoaded && openChatBotPopOver === 'CLOSE') {
      const timeoutId = setTimeout(() => {
        setOpenChatBotPopOver('OPEN')
      }, PENNY_PUSH_MESSAGE_DELAY)

      return () => {
        clearTimeout(timeoutId)
      }
    }
  }, [areChatBotFeaturesLoaded, openChatBotPopOver])
  return (
    <>
      {enableChatBot && isBrowser && areChatBotFeaturesLoaded && (
        <TravelChatBotModal
          isChatBotDialogOpened={isChatBotDialogOpened}
          initialPrompt={askPrompt ?? ''}
          onModalClose={handleModalClose}
          pageName={pageName}
          productType={productType}
        />
      )}
      {!isChatBotDialogOpened && enableChatBot && isBrowser && (
        <ChatNotification
          isChatBotDialogOpened={isChatBotDialogOpened}
          openChatBotPopOver={openChatBotPopOver}
          setChatBotDialogOpeningState={setIsChatBotDialogOpened}
          setOpenChatBotPopOver={setOpenChatBotPopOver}
          onChatBotFeaturesLoaded={handleChatBotFeaturesLoaded}
          pageName={pageName}
          productType={productType}
        />
      )}
    </>
  )
}
